import { createServerFn } from "@tanstack/react-start";
import { getDealApiWorkspacesWorkspaceIdDealsDealIdGet } from "@/lib/api/generated/deals/deals";
import { logError, logInfo } from "@/lib/structured-log";

/**
 * Get Deal detail server function
 */
export const getDealServer = createServerFn({ method: "GET" })
  .validator((data: { workspaceId: string; dealId: string }) => data)
  .handler(async ({ data }) => {
    const { workspaceId, dealId } = data;
    logInfo("deals.get.started", { workspaceId, dealId });

    try {
      const response = await getDealApiWorkspacesWorkspaceIdDealsDealIdGet(workspaceId, dealId);
      if (response.status !== 200) {
        logError("deals.get.failed", { status: response.status, workspaceId, dealId });
        throw new Error(JSON.stringify({ detail: "Failed to get deal", status: response.status }));
      }

      return response.data;
    } catch (error) {
      logError("deals.get.error", {
        error: error instanceof Error ? error.message : "unknown-error",
        workspace_id: workspaceId,
        deal_id: dealId,
      });
      throw error;
    }
  });
